import axios from "axios";
import store from "@/store";
import Swiper, { SwiperOptions } from "swiper";
const banks = [
  { code: "002", bank: "산업은행" },
  { code: "003", bank: "기업은행" },
  { code: "004", bank: "국민은행" },
  { code: "007", bank: "수협은행" },
  { code: "011", bank: "농협은행" },
  { code: "0012", bank: "지역농축협" },
  { code: "020", bank: "우리은행" },
  { code: "023", bank: "SC제일은행" },
  { code: "027", bank: "한국씨티은행" },
  { code: "031", bank: "대구은행(아이엠뱅크)" },
  { code: "032", bank: "부산은행" },
  { code: "034", bank: "광주은행" },
  { code: "035", bank: "제주은행" },
  { code: "037", bank: "전북은행" },
  { code: "039", bank: "경남은행" },
  { code: "045", bank: "새마을금고연합회" },
  { code: "048", bank: "신협" },
  { code: "050", bank: "저축은행" },
  { code: "0054", bank: "HSBC은행" },
  { code: "0055", bank: "도이치은행" },
  { code: "0057", bank: "JP모간체이스은행" },
  { code: "0060", bank: "BOA은행" },
  { code: "0061", bank: "BNP파리바은행" },
  { code: "0062", bank: "중국공상은행" },
  { code: "064", bank: "산림조합" },
  { code: "0067", bank: "중국건설은행" },
  { code: "071", bank: "우체국" },
  { code: "081", bank: "하나은행" },
  { code: "088", bank: "신한은행" },
  { code: "089", bank: "케이뱅크" },
  { code: "090", bank: "카카오뱅크" },
  { code: "092", bank: "토스뱅크" },
  { code: "209", bank: "유안타증권" },
];
let myMixin = {
  computed: {
    mobile() {
      return (
        this.$vuetify.breakpoint.name === "xs" ||
        this.$vuetify.breakpoint.name === "sm"
      );
    }
  },
  methods: {
    move(path) {
      this.$router.push({ path: path });
    },
    backRouting() {
      this.$router.go(-1);
    },
    MakeShortCut(title, t_url, ico, eday) {
      try {
        var todayDate = new Date();
        var expire_day_t = todayDate.setDate(todayDate.getDate() + eday);
        var expire_day = todayDate.toGMTString();
        document.cookie =
          "shortcut = " +
          escape(expire_day_t) +
          "; path=/; expires=" +
          expire_day +
          ";";
        ShortCut.createLink(t_url, ico, title);
        alert("바탕화면에 바로가기 추가되었습니다!");
      } catch (err) {
        alert(err);
      }
    },

    bookmarksite(title, url) {
      // Internet Explorer

      if (document.all) {
        window.external.AddFavorite(url, title);
      }
      // Google Chrome
      else if (window.chrome) {
        alert("Ctrl+D키를 누르시면 즐겨찾기에 추가하실 수 있습니다.");
      }
      // Firefox
      else if (window.sidebar) {
        // firefox
        window.sidebar.addPanel(title, url, "");
      }
      // Opera
      else if (window.opera && window.print) {
        // opera
        var elem = document.createElement("a");
        elem.setAttribute("href", url);
        elem.setAttribute("title", title);
        elem.setAttribute("rel", "sidebar");
        elem.click();
      }
    },
    timeForToday(value) {
      const today = new Date();
      const timeValue = new Date(value);

      const betweenTime = Math.floor(
        (today.getTime() - timeValue.getTime()) / 1000 / 60
      );
      if (betweenTime < 1) return "방금전";
      if (betweenTime < 60) {
        return `${betweenTime}분전`;
      }

      const betweenTimeHour = Math.floor(betweenTime / 60);
      if (betweenTimeHour < 24) {
        return `${betweenTimeHour}시간전`;
      }

      const betweenTimeDay = Math.floor(betweenTime / 60 / 24);
      if (betweenTimeDay < 365) {
        return `${betweenTimeDay}일전`;
      }

      return `${Math.floor(betweenTimeDay / 365)}년전`;
    },
    extractUrl(url) {
      if (url === null || url === undefined || url === "") {
        return "";
      }
      let index = url.indexOf("watch?v=");
      if (index < 0) {
        return null;
      }
      return url.substring(index + 8);
    },

    bankTxt(val) {
      if (val !== null && (val !== undefined ** val) !== "") {
        for (let i = 0; i < banks.length; i++) {
          if (banks[i].code === val) {
            return banks[i].bank;
          }
        }
      }
      return "";
    },
    phoneCheck(val) {
      var regExp_ctn = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
      if (!regExp_ctn.test(val)) {
        alert("휴대폰번호가 유효하지 않습니다.");
        return false;
      } else {
        return true;
      }
    },
    emailCheck(val) {
      // 정규식 - 이메일 유효성 검사
      const regEmail = /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if (val === null || val === undefined || val === "") {
        alert("아이디를 입력해 주세요.");
        return false;
      }
      if (!regEmail.test(val)) {
        alert("이메일 주소가 유효하지 않습니다");
        return false;
      }
      return true;
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    changeHHMM(number) {
      number = number.replace(/[^0-9]/g, "");
      if (number.length >= 3) {
        number = number.slice(0, 2) + ":" + number.slice(2, 4);
      }
      return number;
    },
    downloadItem({ id, filePath, fileOriginalName }) {
      axios({
        method: "get",
        url: `${process.env.VUE_APP_BASEURL}/api/common/fileDown?id=${id}`,
        responseType: "arraybuffer"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Gfuneral" + fileOriginalName); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => console.log("error occured"));
    },
    getCodeList(codeSuperId) {
      const resultAllCodeList = this.$store.getters.getAllCodeList;

      let codeList = [];

      if (codeSuperId === "LOCALDELIVERY") {
        const localDeliveryList = resultAllCodeList.filter(
          v => v.codeSuperId === codeSuperId
        )[0].codeSuperCode;

        localDeliveryList.forEach(v => {
          codeList.push({
            id: v.id,
            text: v.address,
            deliveryCost: v.deliveryCost
          });
        });
      } else if (codeSuperId === "SHOPCATEGORY") {
        const shopCategoryList = resultAllCodeList.filter(
          v => v.codeSuperId === codeSuperId
        )[0].codeSuperCode;

        shopCategoryList.forEach(v => {
          codeList.push({
            id: v.id,
            name: v.name
          });
        });
      } else if (codeSuperId === "CORP") {
        const corpList = resultAllCodeList.filter(
          v => v.codeSuperId === codeSuperId
        )[0].codeSuperCode;

        corpList.forEach(v => {
          codeList.push({
            ...v
          });
        });
      }
      // for (let i = 0; i < resultAllCodeList.length; i++) {
      //   if (resultAllCodeList[i].codeSuperId == codeSuperId) {
      //     for (let j = 0; j < resultAllCodeList[i].codeSuperCode.length; j++) {
      //       codeList.push({
      //         text: resultAllCodeList[i].codeSuperCode[j].codeName,
      //         value: resultAllCodeList[i].codeSuperCode[j].codeId,
      //         codeSubText: resultAllCodeList[i].codeSuperCode[j].codeSubText
      //       });
      //     }
      //   }
      // }
      /* 이름순으로 정렬 */
      codeList.sort(function(a, b) {
        // 오름차순
        return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
      });

      return codeList;
    },
    getCodeListForSort(codeSuperId) {
      const resultAllCodeList = this.$store.getters.getAllCodeList;
      let codeList = [];
      for (let i = 0; i < resultAllCodeList.length; i++) {
        if (resultAllCodeList[i].codeSuperId == codeSuperId) {
          for (let j = 0; j < resultAllCodeList[i].codeSuperCode.length; j++) {
            codeList.push({
              text: resultAllCodeList[i].codeSuperCode[j].codeName,
              value: resultAllCodeList[i].codeSuperCode[j].codeId,
              codeSubText: resultAllCodeList[i].codeSuperCode[j].codeSubText,
              sort: resultAllCodeList[i].codeSuperCode[j].codeSort
            });
          }
        }
      }
      /* 이름순으로 정렬 */
      codeList.sort(function(a, b) {
        // 오름차순
        return a.sort < b.sort ? -1 : a.sort > b.sort ? 1 : 0;
        // 광희, 명수, 재석, 형돈
      });

      return codeList;
    },
    getCodeSubList(codeSuperId, codeId) {
      const resultAllCodeList = this.$store.getters.getAllCodeList;
      let codeSubList = [];
      for (let i = 0; i < resultAllCodeList.length; i++) {
        if (resultAllCodeList[i].codeSuperId == codeSuperId) {
          for (let j = 0; j < resultAllCodeList[i].codeSuperCode.length; j++) {
            for (
              let k = 0;
              k < resultAllCodeList[i].codeSuperCode[j].codeCodeSub.length;
              k++
            ) {
              if (
                codeId === undefined ||
                codeId === null ||
                resultAllCodeList[i].codeSuperCode[j].codeId === codeId
              ) {
                codeSubList.push({
                  text:
                    resultAllCodeList[i].codeSuperCode[j].codeCodeSub[k]
                      .codeSubName,
                  value:
                    resultAllCodeList[i].codeSuperCode[j].codeCodeSub[k]
                      .codeSubId
                });
              }
            }
          }
        }
      }
      return codeSubList;
    },
    comma(num) {
      var len, point, str;
      num = num + "";
      point = num.length % 3;
      len = num.length;
      str = num.substring(0, point);
      while (point < len) {
        if (str != "") str += ",";
        str += num.substring(point, point + 3);
        point += 3;
      }
      return str;
    },

    computedPrice(price, dc = 0) {
      return this.comma(price * (1 - dc / 100));
    },

    changeTxtToHtml(txt) {
      txt = txt.replace(/(?:\r\n|\r|\n)/g, "<br />");
      txt = txt.split("\n").join("<br />");
      return txt;
    },
    fileExtension(fileName) {
      let fileLength = fileName.length;
      let lastDot = fileName.lastIndexOf(".");
      let fileExtension = fileName.substring(lastDot + 1, fileLength);
      return fileExtension;
    },
    allLoadingEventTablet() {
      //동의 버튼 클릭 시
      $(".chkArea").each(function() {
        $(this)
          .find(".chkBox")
          .each(function() {
            $(this)
              .find(".agree")
              .on("click", function() {
                if (
                  !$(this)
                    .parents(".chkBox")
                    .hasClass("on")
                ) {
                  $(this)
                    .parents(".chkArea")
                    .find(".chkBox")
                    .removeClass("on");
                  $(this)
                    .parents(".chkBox")
                    .addClass("on");
                } else {
                  $(this)
                    .parents(".chkBox")
                    .removeClass("on");
                }
              });
          });
      });

      $(".font a").each(function(q) {
        $(this).on("click", function() {
          if (q == 0) {
            $(".typing").removeClass("font2 font3");
            $(".typing").addClass("font1");
          } else if (q == 1) {
            $(".typing").removeClass("font1 font3");
            $(".typing").addClass("font2");
          } else if (q == 2) {
            $(".typing").removeClass("font1 font2");
            $(".typing").addClass("font3");
          }
        });
      });

      $(window).resize(function() {
        $(".conArea").css("min-height", $(window).height());
        //$(".wrap").height($(window).height())
      });
      $(window).resize();
    },

    allLoadingEvent() {
      var $sitemapBtn = $(".btn_sitemap"),
        $mypageBtn = $(".btn_mypage"),
        $jangjiBtn = $(".btn_jangji"),
        $documentBtn = $(".btn_document"),
        $serviceBtn = $(".btn_service"),
        $sitemapCloseBtn = $(".btn_sitemap_colse"),
        $sitemapCloseBtn2 = $(".btn_sitemap_colse2"),
        $jangjiCloseBtn = $(".btn_jangji_colse"),
        $documentCloseBtn = $(".btn_document_colse"),
        $documentCloseBtn2 = $(".btn_cancel"),
        $serviceCloseBtn = $(".btn_service_colse"),
        $header = $("#header .sitemap"),
        $header2 = $("#header .sitemap_mypage"),
        $header3 = $(".modal_pop"),
        $header4 = $(".document_pop"),
        $header5 = $(".service_pop");

      var isMenu = false;

      // sitemap메뉴
      $sitemapBtn.unbind("click");
      $sitemapBtn.on("click", function(e) {
        $header.addClass("active");
        store.commit("START_DEEMED");
        return false;
      });

      $sitemapCloseBtn.unbind("click");
      $sitemapCloseBtn.on("click", function(e) {
        $header.removeClass("active");
        store.commit("END_DEEMED");
        return false;
      });

      $mypageBtn.unbind("click");
      $mypageBtn.on("click", function(e) {
        $header2.addClass("active");
        store.commit("START_DEEMED");
        return false;
      });

      $sitemapCloseBtn2.unbind("click");
      $sitemapCloseBtn2.on("click", function(e) {
        $header2.removeClass("active");
        store.commit("END_DEEMED");
        return false;
      });

      $sitemapCloseBtn.unbind("click");
      $sitemapCloseBtn.on("click", function(e) {
        $header.removeClass("active");
        store.commit("END_DEEMED");
        return false;
      });

      //$jangjiBtn.unbind('click');
      //$jangjiBtn.on('click', function (e) {
      //	$header3.addClass('active');
      //	store.commit('START_DEEMED');
      //	return false;
      //});

      $jangjiCloseBtn.unbind("click");
      $jangjiCloseBtn.on("click", function(e) {
        $header3.removeClass("active");
        store.commit("END_DEEMED");
        return false;
      });

      $documentBtn.unbind("click");
      $documentBtn.on("click", function(e) {
        $header4.addClass("active");
        store.commit("START_DEEMED");
        return false;
      });

      $documentCloseBtn.unbind("click");
      $documentCloseBtn.on("click", function(e) {
        $header4.removeClass("active");
        store.commit("END_DEEMED");
        return false;
      });

      $documentCloseBtn2.unbind("click");
      $documentCloseBtn2.on("click", function(e) {
        $header4.removeClass("active");
        store.commit("END_DEEMED");
        return false;
      });

      //$serviceBtn.unbind('click');
      //$serviceBtn.on('click', function (e) {
      //	$header5.addClass('active');
      //	store.commit('START_DEEMED');
      //	return false;
      //});

      //$serviceCloseBtn.unbind('click');
      //$serviceCloseBtn.on('click', function (e) {
      //	$header5.removeClass('active');
      //	store.commit('END_DEEMED');
      //	return false;
      //});

      // faq 클릭시 설명
      var $subTopMenu = $(".faq_list .q_btn");
      $subTopMenu.unbind("click");
      $subTopMenu.on("click", function() {
        var index = $(this).index();
        if (
          $(this)
            .parent()
            .hasClass("active")
        ) {
          $(this)
            .parent()
            .removeClass("active");
        } else {
          $(this)
            .parent()
            .addClass("active");
        }
        return false;
      });

      // 전광판 서비스 설명
      $(".service_tab li").click(function() {
        var tabType = $(this).index();
        var realno = tabType + 1;
        $(".service_contents")
          .eq(tabType)
          .show()
          .siblings(".service_contents")
          .hide();
        $(".service_tab li").each(function(index) {
          $(this).addClass("active");
          if (tabType != index) {
            $(this).removeClass("active");
          }
        });
        this.roll(realno);
      });

      var chk = "";
      if (!chk) {
        this.roll(1);
      }

      // 전광판 관리
      $(".service_adm_tab li").click(function() {
        var tabType = $(this).index();
        $(".service_contents")
          .eq(tabType)
          .show()
          .siblings(".service_contents")
          .hide();
        $(".service_adm_tab li").each(function(index) {
          $(this).addClass("active");
          if (tabType != index) {
            $(this).removeClass("active");
          }
        });
      });

      $("input").unbind("each");
      $("input").each(function() {
        $(this).on("focusin", function() {
          $(this).addClass("inputfocus");
        });
        $(this).on("focusout", function() {
          $(this).removeClass("inputfocus");
        });
      });
      $("select").unbind("each");
      $("select").each(function() {
        $(this).on("focusin", function() {
          $(this).addClass("inputfocus");
        });
        $(this).on("focusout", function() {
          $(this).removeClass("inputfocus");
        });
      });

      $("input").attr("autocomplete", "off");
    },
    roll(no) {
      var swiper = new Swiper(".service_swiper" + no, {
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    }
  }
};
export default myMixin;
